import React from "react";
import { Link } from "react-router-dom";

const POLICY_LINKS = [
  { to: "/policy/about", label: "About" },
  { to: "/policy/disclaimer", label: "Disclaimer" },
  { to: "/policy/privacy", label: "Privacy Policy" },
  { to: "/policy/refund", label: "Refund Policy" },
  { to: "/policy/terms", label: "Terms & Conditions" },
  { to: "/policy/shipping", label: "Shipping Policy" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 bg-black/80 mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-semibold tracking-tight text-base text-white">
            Gareebo Ka Filmmaker
          </div>
          <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500 mt-1">
            Legally Owned By Nilesh Rajendra Barnawal
          </div>
          <p className="text-zinc-500 text-sm mt-4 max-w-sm leading-relaxed">
            Cinematic 3D LUTs from a single reference. Made for indie filmmakers,
            YouTubers and storytellers on a tight budget.
          </p>
        </div>

        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-3">
            Site Policies
          </div>
          <ul className="space-y-2">
            {POLICY_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.to.split("/").pop()}`}
                  className="text-sm text-zinc-300 hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-3">
            Support
          </div>
          <a
            href="mailto:techneel23@gmail.com"
            data-testid="footer-support-email"
            className="text-sm text-zinc-200 hover:text-white"
          >
            techneel23@gmail.com
          </a>
          <div className="text-[11px] font-mono text-zinc-600 mt-1">
            We reply within 24 hours on working days.
          </div>
          <div className="flex items-center gap-3 mt-4">
            <a
              data-testid="footer-instagram"
              href="https://instagram.com/neelv007"
              target="_blank"
              rel="noreferrer"
              className="text-[11px] font-mono text-zinc-400 hover:text-fuchsia-300"
            >
              IG · @neelv007
            </a>
            <span className="text-zinc-700">·</span>
            <a
              data-testid="footer-twitter"
              href="https://twitter.com/neelv007"
              target="_blank"
              rel="noreferrer"
              className="text-[11px] font-mono text-zinc-400 hover:text-sky-300"
            >
              X · @neelv007
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500">
          <span>© {year} Gareebo Ka Filmmaker — All rights reserved.</span>
          <span>Made with grit in India</span>
        </div>
      </div>
    </footer>
  );
}
